<template>
  <div  id='methodologyTab' v-if="propMethodologyDetail">
    <treeGrid  v-if="item" ref="methodologyTreeGrid" sum-text="sum" index-text="#" :data="item" :columns="columns"
      :stripe="props.stripe" :border="props.border" :show-header="props.showHeader" :show-summary="props.showSummary"
      :show-row-hover="props.showRowHover" :show-index="props.showIndex" :tree-type="props.treeType"
      :is-fold="props.isFold" :expand-type="props.expandType" :selection-type="props.selectionType">
      <template slot="startDate" scope="scope">
        <b-input-group class="form-inline">
          <b-form-input id="start-date" name="start-date" type="date" v-model="scope.row.startDate" size="sm"
            class="custom-input  rounded" data-vv-as="start date" placeholder="YYYY-MM-DD"></b-form-input>
        </b-input-group>
      </template>
      <template slot="endDate" scope="scope">
        <b-input-group class="form-inline">
          <b-form-input id="start-date" name="start-date" type="date" v-model="scope.row.endDate" size="sm"
            class="custom-input  rounded" data-vv-as="start date" placeholder="YYYY-MM-DD"></b-form-input>
        </b-input-group>
      </template>
      <template slot="add" scope="scope">
        <div class="cursor-pointer" @click="showModal(scope.row)" v-b-modal.export>
          <!-- <b-icon class="cursor-pointer" scale="2" variant="secondary" icon="plus-square-fill" sm /> -->
          <span class="icon plus"></span>
        </div>
      </template>
      <template slot="del" scope="scope">
        <div class="cursor-pointer" @click="deleteChildObj(scope.row)">
          <!-- <b-icon class="cursor-pointer" scale="2" variant="secondary" icon="dash-square-fill" sm /> -->
          <span class="icon minus"></span>
        </div>
      </template>
    </treeGrid>
    <b-modal ref="newStepModal" id="export" :hide-footer="true" size="md" title="Add Methodology">
      <div>
        <b-form-row>
          <b-col>
            <label for="step">Step</label>
            <b-input id='step' size="sm" class="custom-input" v-model="newStep.step" />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <label for="start-date">Start Date</label>
            <b-form-input id="start-date" name="start-date" type="date" size="sm" class="custom-input  rounded"
              data-vv-as="start date" placeholder="YYYY-MM-DD" v-model="newStep.startDate"></b-form-input>
          </b-col>
          <b-col>
            <label for="end-date">End Date</label>
            <b-form-input id="end-date" name="end-date" type="date" size="sm" class="custom-input  rounded"
              data-vv-as="end date" placeholder="YYYY-MM-DD" v-model="newStep.endDate"></b-form-input>
          </b-col>
        </b-form-row>
        <div class="btn-wrap">
          <b-button class="btn" variant="primary" block @click="addChildObj()">Create</b-button>
          <b-button class="btn" variant="secondary" block @click="hideModal()">Cancel</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import treeGrid from 'vue-table-with-tree-grid'
export default {
  props: ['propMethodologyDetail', 'propMembers'],
  name: "methodologyManagementGrid",
  components: {
    treeGrid
  },
  data() {
    return {
      props: {
        stripe: false,
        border: false,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: false,
        treeType: true,
        isFold: false, //default가 전부 열려있게 할 지 여부
        expandType: false,
        selectionType: false

      },
      newStep: {
        parent : {
          children : []
        },
        step: '',
        startDate: '',
        endDate: '',
        children : []
      },
      item: [],
      columns: []
    };
  },
  created() {
    this.setCols();
    this.item = this.propMethodologyDetail;
  },
  watch: {
    propMethodologyDetail:{
      handler(){
        this.item = this.propMethodologyDetail;
      },
      deep : true
    }
  },
  computed: {
    memberOptions() {
      return this.propMembers.map(member => {  
        return {
          text: member.userName,
          value: member.userId
        };
      });
    }
  },
  methods: {
    setCols() {
      this.columns = [
        {
          label: "Title",
          prop: "step",
          minWidth: "300rem",
          maxWidth: "600rem",
          headerAlign: "center",
        },
        // ---------- devMethodology Insert API 구현 전 까지 주석
        // {
        //   label: "",
        //   width: "30rem",
        //   type: "template",
        //   template: "add",
        //   headerAlign: "center",
        //   align: "center"
        // },
        // {
        //   label: "",
        //   width: "30rem",
        //   type: "template",
        //   template: "del",
        //   headerAlign: "center",
        //   align: "center"
        // },
        // ---------- devMethodology Insert API 구현 전 까지 주석
        {
          label: "Start Date",
          prop: "startDate",
          width: "180rem",
          headerAlign: "center",
          align: "center",
          // type: 'template',
          // template: 'startDate',

        },
        {
          label: "End Date",
          prop: "endDate",
          width: "180rem",
          headerAlign: "center",
          align: "center",
          // type: 'template',
          // template: 'endDate',
        },
      ]
    },
    findObjectByStep(objects, targetStep) {
      for (const obj of objects) {
        if (obj.step === targetStep) {
          return {
            target : obj,
            targetGroup : objects
          }; // 찾았을 경우 해당 객체 반환
        }
        if (obj.children) {
          const found = this.findObjectByStep(obj.children, targetStep); // 재귀적으로 하위 객체 탐색
          if (found) {
            return found; // 하위에서 찾았을 경우 해당 객체 반환
          }
        }
      }
      return null; // 찾지 못한 경우 null 반환
    },
    addChildObj() {
      this.$refs['newStepModal'].hide();
      let step = {
        type: "Corpoactivity",
        step: this.newStep.step,
        startDate: this.newStep.startDate,
        endDate: this.newStep.endDate,
        chidlren : []
      }
      if (!this.newStep.parent.children) {
        this.$set(this.newStep.parent, 'children', [])
      }
      this.$set(this.newStep.parent.children, this.newStep.parent.children.length, step)      
    },
    deleteChildObj(obj) {
      let targetInfo = this.findObjectByStep(this.item, obj.step);
      let index = targetInfo.targetGroup.findIndex(item => item.step===targetInfo.target.step);
      if(index!==-1){
        targetInfo.targetGroup.splice(index,1);
      }
      
      // 건별 삭제
    },
    showModal(obj) {
      this.newStep = {
        parent: {},
        step: '',
        startDate: null,
        endDate: null,
      }
      this.newStep.parent = this.findObjectByStep(this.item, obj.step).target;
      this.$refs['newStepModal'].show();
    },
    hideModal() {
      this.$refs['newStepModal'].hide();
    }
  }
};
</script>
<style>
#methodologyTab .btn {
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

/* 퍼블리싱 신규 스타일 작성 START */
#methodologyTab {
  margin-top: 2rem;
}

#methodologyTab .zk-table {
  border: none;
}

#methodologyTab .zk-table__header-row {
  background-color: transparent;
  border-bottom: none;
}

#methodologyTab .zk-table__header-row th div {
  min-height: 60px;
  padding: 19px 10px;
  background-color: #F6F6FA;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

#methodologyTab .zk-table__header-row th:first-child div {
  border-radius: 10px 0 0 10px;
}

#methodologyTab .zk-table__header-row th:last-child div {
  width: 100%;
  height: 100%;
  border-radius: 0 10px 10px 0;
}

#methodologyTab .zk-table__body-row {
  height: 60px;
}

#methodologyTab .zk-table__body-row .zk-table__cell-inner {
  padding: 10px;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#methodologyTab .zk-table__body-row .zk-table__cell-inner span {
  display: flex;
  align-items: center;
}

#methodologyTab .zk-table__cell-inner .zk-table--tree-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  font-size: 0;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6.24 8.68C6.12 8.84 5.88 8.84 5.76 8.68L2.61 4.48C2.46167 4.28223 2.60279 4 2.85 4L9.15 4C9.39721 4 9.53833 4.28223 9.39 4.48L6.24 8.68Z" fill="black"/></svg>');
  background-repeat: no-repeat;
}

#methodologyTab .zk-table__cell-inner .zk-table--tree-icon.zk-icon-plus-square-o {
  transform: rotate(-90deg);
}

#methodologyTab .icon.plus {
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #747480;
}

#methodologyTab .icon.plus::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 1px;
  background-color: #FFF;
}

#methodologyTab .icon.plus::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1px;
  height: 8px;
  background-color: #FFF;
}

#methodologyTab .icon.minus {
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #747480;
}

#methodologyTab .icon.minus::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 1px;
  background-color: #FFF;
}

#export .modal-dialog {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  font-family: 'NanumGothic';
}

#export .modal-dialog .modal-content {
  border-radius: 20px;
  overflow: hidden;
}

#export .modal-header {
  align-items: center;
  padding: 40px 2.083vw 0;
  border-bottom: 0;
}

#export .modal-header .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

#export .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;
  font-size: 0;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#export .modal-body > div {
  padding: 40px 2.083vw 50px;
}

#export .modal-body input.form-control {
  margin-bottom: 30px;
  background-color: #FFF;
}

#export .modal-body .custom-select {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  margin-bottom: 30px;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

#export .modal-body .btn-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 10px;
}

#export .modal-body .btn-wrap .btn {
  width: 140px;
  height: 40px;
  margin-top: 0;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  border: none;
}

#export .modal-body .btn-wrap .btn-primary {
  background-color: #2E2E38;
  color: #FFE600;
}

#export .modal-body .btn-wrap .btn-secondary {
  background-color: #747480;
  color: #FFF;
}
/* 퍼블리싱 신규 스타일 작성 END */
</style>

<style scoped>

/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

</style>